"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.valueMessages = exports.Value = void 0;
const schema_1 = require("../../../../../schema");
var Value;
(function (Value) {
    Value["POSITIVE"] = "POSITIVE";
    Value["NEGATIVE"] = "NEGATIVE";
})(Value || (exports.Value = Value = {}));
exports.valueMessages = {
    [Value.POSITIVE]: {
        id: "ltx.phaseI.labProcedures.standardLabProcedures.coombsIndirect.value.POSITIVE",
        defaultMessage: "Pozitív"
    },
    [Value.NEGATIVE]: {
        id: "ltx.phaseI.labProcedures.standardLabProcedures.coombsIndirect.value.NEGATIVE",
        defaultMessage: "Negatív"
    }
};
const value = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Value.POSITIVE),
    schema_1.Schema.singleChoiceItem(Value.NEGATIVE)
])
    .interpretation({ vocab: "ltx", code: "coombs_indirect" })
    .tag({ vocab: "loinc", code: "13946-9" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value });
